import { Component } from '@angular/core';
import { EcaIconModule } from '@drc-eca/eca-components-lib';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'eca-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [EcaIconModule, RouterOutlet]
})
export class AppComponent {

  constructor(

  ) { }

}
